export default __webpack_public_path__ + "static/loading-9dcb0cef7fd12f3eada2c549de3b36d2.gif";